<template>
  <div class="dan">
    <div class="main">
      <div class="sub-dan"
            :class="{checked:checked(data)}"
            v-on:click="handleClick(data.name,data.name,data.level)"
      >
      {{data.name}}
    </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['data', 'selectedDans'],
    name: 'dan',
    methods: {
      handleClick (dan,label,level) {
        this.$emit('selected', { dan: dan,label:label,level:level,count:1 })
      },
      checked (subDan) {
        let index = this.selectedDans.findIndex((x) => {
          return x.dan === this.data.name
        })

        if (index === -1) {
          return false
        } else {
          return true
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .dan
    margin 5px
    text-align center
    .main
      .sub-dan
        height 30px
        line-height 30px
        width 40px
        border 1px solid gray
        margin 5px
      .checked
        background-color #409EFF
        color #FFF
    .star
      display blcok
      .star-num
        width 100px
</style>
